var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-gray-400 rounded-3xl p-4"},[_c('div',{staticClass:"font-bold text-xl border-b-2 pb-4"},[_c('router-link',{class:{ 'text-primary': _vm.isActive('AccountReviewIndex') },attrs:{"to":{ name: 'AccountReviewIndex' }}},[_vm._v(" Waiting For Review ")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }